import {
  SchedulerEditItem,
  SchedulerItem,
} from '@progress/kendo-react-scheduler';
import * as React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
export const EditItemWithDynamicTitle = (props) => {
  return <SchedulerEditItem {...props} title={GenerateTitle(props.dataItem)} />;
};
const GenerateTitle = (dataItem) => {
  const appointmentData = useSelector(
    (state) => state.jobOpportunity.appointmentData
  );
  const appointmentValue = appointmentData.find(
    (t) => t.id === dataItem.AppointmentType
  );
  return (
    <div title={`Time: ${moment(dataItem.Start).format('h:mm A')} - ${moment(dataItem.End).format('h:mm A')}, Dates: (${moment(dataItem.Start).format('YYYY-MM-DD')} - ${moment(dataItem.End).format('YYYY-MM-DD')}), Patient Name: ${dataItem.PatientName}, Appointment name: ${appointmentValue?.name ? appointmentValue.name : null}`}>
        <span className='block'>{appointmentValue?.name ? appointmentValue.name : null}</span>
        <span className='block'>{dataItem?.PatientName}</span>
    </div>
  )
};
{/*`${dataItem.Start} - ${dataItem.End} - ${dataItem.PatientName} - ${
    appointmentValue?.name ? appointmentValue.name : null
  }`; */}
export const CustomItem = (props) => {
//  console.log(`🚀 ~ file: custom-item.jsx ~ line: 24 :`, { props: props });
 const location = useLocation();
 const state = location?.state ?? '';
 const pageName = state?.pageName ?? '';
  return (
    <SchedulerItem
      {...props}
      style={{
        ...props.style,
        backgroundColor:props?.dataItem?.isUnclaimedOccurrence? "rgb(255, 225, 0)" : (props?.dataItem?.occurrenceCorrectionType === +1 && props?.dataItem?.isCheckedOut === false && pageName === 'awaitingcorrection' && location?.pathname === "/daily-encounter-info") ? 'red' :   (location?.pathname === "/daily-encounter-info" || props?.dataItem?.IsClaimed) ? "green":"#BDD7FA"
      }}
    />
  );
};

// rgb(255, 174, 26)